import { Divider, HStack, Pressable, Text, VStack } from 'native-base';
import React, { useCallback, useContext } from 'react';
import EditIcon from '../../../../assets/icons/EditIcon/EditIcon';
import { NavigationContext } from '../../../../contexts';
import get from 'lodash.get';
import Functions from '../../../../utils/Functions';
const formatText = (value, type) => {
  if (type === 'dollar') return Functions.toUSD(value);
  return value;
};
const ReviewInformationBox = _ref => {
  let {
    title,
    isEdit,
    stepNumber,
    valueKey,
    isHeaderNeeded,
    headerValue,
    type = '',
    id
  } = _ref;
  const {
    setStep,
    review,
    logUserEvent,
    type: eventType
  } = useContext(NavigationContext);
  const handleEdit = step => {
    setStep(step);
  };
  const renderCaption = useCallback(each => {
    var _review$stepNumber;
    return /*#__PURE__*/React.createElement(HStack, null, isHeaderNeeded ? /*#__PURE__*/React.createElement(Text, {
      fontSize: "21",
      lineHeight: "2xs",
      maxW: "65%",
      key: each
    }, `${headerValue}: `) : null, /*#__PURE__*/React.createElement(Text, {
      fontSize: "21",
      lineHeight: "2xs",
      maxW: "65%",
      key: each
    }, (_review$stepNumber = review[stepNumber]) !== null && _review$stepNumber !== void 0 && _review$stepNumber.label ? review[stepNumber].label : formatText(get(review, [stepNumber, each], ''), type)));
  }, [headerValue, isHeaderNeeded, review, stepNumber, type]);
  return /*#__PURE__*/React.createElement(VStack, {
    mb: "8",
    space: "2",
    key: id
  }, /*#__PURE__*/React.createElement(Divider, {
    orientation: "horizontal",
    mb: "2"
  }), /*#__PURE__*/React.createElement(VStack, {
    space: "3"
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    h: "12"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "2xl",
    fontWeight: "500",
    lineHeight: "2xs",
    mb: "1",
    accessibilityLabel: title,
    testID: title,
    accessibilityRole: "text"
  }, title), isEdit ? /*#__PURE__*/React.createElement(Pressable, {
    accessibilityLabel: `edit icon for ${title}`,
    testID: `edit icon for ${title}`,
    onPress: () => {
      logUserEvent({
        type: eventType,
        action: `${title === null || title === void 0 ? void 0 : title.split(' ').join('')}ReviewEditClicked`
      });
      handleEdit(stepNumber);
    }
  }, /*#__PURE__*/React.createElement(EditIcon, {
    width: "30"
  })) : null), /*#__PURE__*/React.createElement(VStack, {
    testID: "caption",
    space: "1"
  }, valueKey.map(renderCaption))));
};
export default /*#__PURE__*/React.memo(ReviewInformationBox);
//# sourceMappingURL=index.js.map